import { IconName } from "@elearning-platform/ui";

import { ReactComponent as ModuleIcon } from "../../images/knowledgeBase.svg";

export const Config = {
  moduleName: "knowledgeBase",
  dependencies: [],
  label: "learning.pageTitle",
  Icon: ModuleIcon,
  urls: ["/lekcje"],
  routeName: "api_learning_list",
  routes: {},
  options: {},
  theme: {},
  modernIconName: IconName.PageKnowledgeBase,
};
